import { useAppSelector } from 'store/hooks';

const useIsSepaPaymentFailed = () => {
  const isSepaPaymentFailed = useAppSelector(state => state.customer.sepaPaymentFailed);

  return isSepaPaymentFailed;
};

export default useIsSepaPaymentFailed;
